export const languages: string[] = [
  "Aboriginal English, so described",
  "Acehnese",
  "Acholi",
  "Adnymathanha",
  "African Languages",
  "Afrikaans",
  "Akan",
  "Alawa",
  "Albanian",
  "Alngith",
  "Alyawarr",
  "American Languages",
  "Amharic",
  "Amurdak",
  "Anindilyakwa",
  "Anmatyerr",
  "Antekerrepenh",
  "Antikarinya",
  "Anuak",
  "Arabana",
  "Arabic",
  "Arandic",
  "Armenian",
  "Arnhem Land and Daly River Region Languages",
  "Aromunian (Macedo-Romanian)",
  "Arrernte",
  "Assamese",
  "Assyrian Neo-Aramaic",
  "Auslan",
  "Azeri",
  "Baanbay",
  "Badimaya",
  "Balinese",
  "Balochi",
  "Bandjalang",
  "Banyjima",
  "Barababaraba",
  "Bardi",
  "Bari",
  "Basque",
  "Bassa",
  "Batjala",
  "Belorussian",
  "Bemba",
  "Bengali",
  "Bidjara",
  "Bikol",
  "Bilinarra",
  "Bisaya",
  "Bislama",
  "Bosnian",
  "Bulgarian",
  "Bunuba",
  "Burarra",
  "Burarran",
  "Burmese",
  "Burmese and Related Languages",
  "Cantonese",
  "Cape York Peninsula Languages",
  "Catalan",
  "Cebuano",
  "Celtic",
  "Central Anmatyerr",
  "Chaldean Neo-Aramaic",
  "Chin Haka",
  "Chinese",
  "Croatian",
  "Czech",
  "Czechoslovakian, so described",
  "Daatiwuy",
  "Dadi Dadi",
  "Dalabon",
  "Dan (Gio-Dan)",
  "Danish",
  "Dari",
  "Dhalwangu",
  "Dhanggatti",
  "Dhangu",
  "Dharawal",
  "Dhay'yi",
  "Dhivehi",
  "Dhuwal",
  "Dhuwala",
  "Dhuwaya",
  "Dinka",
  "Diyari",
  "Djabugay",
  "Djabwurrung",
  "Djambarrpuyngu",
  "Djangu",
  "Djapu",
  "Djarrwark",
  "Djinang",
  "Djinba",
  "Dravidian",
  "Dutch",
  "Dyirbal",
  "Eastern Anmatyerr",
  "Eastern Arrernte",
  "Estonian",
  "Ewe",
  "Fijian",
  "Fijian Hindustani",
  "Filipino",
  "Finnish",
  "Finnish and Related Languages",
  "French",
  "Frisian",
  "Fulfulde",
  "Ga",
  "Gaelic (Scotland)",
  "Galpu",
  "Gambera",
  "Gamilaraay",
  "Ganalbingu",
  "Garrwa",
  "Garuwali",
  "Georgian",
  "German",
  "Gilbertese",
  "Girramay",
  "Githabul",
  "Golumala",
  "Gooniyandi",
  "Greek",
  "Gudanji",
  "Gudjal",
  "Gujarati",
  "Gumatj",
  "Gumbaynggir",
  "Gundjeihmi",
  "Gun-nartpa",
  "Gupapuyngu",
  "Gurindji",
  "Gurindji Kriol",
  "Gurr-goni",
  "Guugu Yimidhirr",
  "Guyamirrilili",
  "Hakka",
  "Harari",
  "Hausa",
  "Hawaiian English",
  "Hazaraghi",
  "Hebrew",
  "Hindi",
  "Hmong",
  "Hmong-Mien",
  "Hungarian",
  "Iban",
  "Iberian Romance",
  "Icelandic",
  "Igbo",
  "IIokano",
  "Ilonggo (Hiligaynon)",
  "Indo-Aryan",
  "Indonesian",
  "Invented Languages",
  "Iranic",
  "Irish",
  "Italian",
  "Iwaidja",
  "Jaminjung",
  "Japanese",
  "Jaru",
  "Javanese",
  "Jawi",
  "Jawoyn",
  "Jingulu",
  "Kalaw Kawaw Ya/Kalaw Lagaw Ya",
  "Kanai",
  "Kannada",
  "Karajarri",
  "Karen",
  "Kariyarra",
  "Kartujarra",
  "Kashmiri",
  "Kaurna",
  "Kayardild",
  "Kaytetye",
  "Keerray-Woorroong",
  "Key Word Sign Australia",
  "Khmer",
  "Kija",
  "Kikuyu",
  "Kimberley Area Languages",
  "Kinyarwanda (Rwanda)",
  "Kirundi (Rundi)",
  "Kiwai",
  "Koko-Bera",
  "Konkani",
  "Korean",
  "Kpelle",
  "Krahn",
  "Krio",
  "Kriol",
  "Kugu Muminh",
  "Kukatha",
  "Kukatja",
  "Kuku Yalanji",
  "Kunbarlang",
  "Kune",
  "Kuninjku",
  "Kunwinjku",
  "Kunwinjkuan",
  "Kurdish",
  "Kuuk Thayorre",
  "Kuuku-Ya'u",
  "Kuwema",
  "Ladji Ladji",
  "Lamalama",
  "Lao",
  "Lardil",
  "Larrakiya",
  "Latin",
  "Latvian",
  "Letzeburgish",
  "Liberian (Liberian English)",
  "Light Warlpiri",
  "Lingala",
  "Lithuanian",
  "Liyagalawumirr",
  "Liyagawumirr",
  "Loma (Lorma)",
  "Luganda",
  "Lumun (Kuku Lumun)",
  "Luo",
  "Luritja",
  "Macedonian",
  "Madarrpa",
  "Madi",
  "Malak Malak",
  "Malay",
  "Malayalam",
  "Malngin",
  "Maltese",
  "Mandaean (Mandaic)",
  "Mandarin",
  "Mandinka",
  "Mangala",
  "Mangarrayi",
  "Manggalili",
  "Mann",
  "Manyjalpingu",
  "Manyjilyjarra",
  "Maori (Cook Island)",
  "Maori (New Zealand)",
  "Marathi",
  "Maringarr",
  "Marra",
  "Marramaninyshi",
  "Marrangu",
  "Marridan (Maridan)",
  "Marrithiyel",
  "Martu Wangka",
  "Matngala",
  "Maung",
  "Mauritian Creole",
  "Mayali",
  "Meriam Mir",
  "Middle Eastern Semitic Languages",
  "Min Nan",
  "Miriwoong",
  "Mirning",
  "Mon",
  "Mongolian",
  "Mon-Khmer",
  "Moro (Nuba Moro)",
  "Morrobalama",
  "Motu (HiriMotu)",
  "Mudburra",
  "Murrinh Patha",
  "Muruwari",
  "Na-kara",
  "Narungga",
  "Nauruan",
  "Ndebele",
  "Ndjebbana (Gunavidji)",
  "Nepali",
  "Ngaanyatjarra",
  "Ngalakgan",
  "Ngaliwurru",
  "Ngandi",
  "Ngan'gikurunggurr",
  "Ngardi",
  "Ngarinyin",
  "Ngarinyman",
  "Ngarluma",
  "Ngarrindjeri",
  "Ngatjumaya",
  "Nhangu",
  "Niue",
  "Norf'k-Pitcairn",
  "Northern Desert Fringe Area Languages",
  "Norwegian",
  "Nuer",
  "Nungali",
  "Nunggubuyu",
  "Nyamal",
  "Nyangumarta",
  "Nyanja (Chichewa)",
  "Nyikina",
  "Nyungar",
  "Oceanian Pidgins and Creoles",
  "Oriya",
  "Oromo",
  "Other Australian Indigenous Languages",
  "Other Eastern Asian Languages",
  "Other Eastern European Languages",
  "Other Southeast Asian Languages",
  "Other Southern Asian Languages",
  "Other Southern European Languages",
  "Other Southwest and Central Asian Languages",
  "Other Yolngu Matha",
  "Paakantyi",
  "Pacific Austronesian Languages",
  "Palyku/Nyiyaparli",
  "Pampangan",
  "Papua New Guinea Languages",
  "Pashto",
  "Persian (excluding Dari)",
  "Pintupi",
  "Pitjantjatjara",
  "Polish",
  "Portuguese",
  "Punjabi",
  "Rembarrnga",
  "Rirratjingu",
  "Ritharrngu",
  "Rohingya",
  "Romanian",
  "Romany",
  "Rotuman",
  "Russian",
  "Samoan",
  "Scandinavian",
  "Serbian",
  "Serbo-Croatian/Yugoslavian, so described",
  "Seychelles Creole",
  "Shilluk",
  "Shona",
  "Sign Languages",
  "Sindhi",
  "Sinhalese",
  "Slovak",
  "Slovene",
  "Solomon Islands Pijin",
  "Somali",
  "Southeast Asian Austronesian Languages",
  "Spanish",
  "Swahili",
  "Swedish",
  "Tagalog",
  "Tai",
  "Tamil",
  "Tatar",
  "Telugu",
  "Tetum",
  "Thai",
  "Thaynakwith",
  "Themne",
  "Tibetan",
  "Tigre",
  "Tigrinya",
  "Timorese",
  "Tiwi",
  "Tjungundji",
  "Tjupany",
  "Tok Pisin (Neomelanesian)",
  "Tokelauan",
  "Tongan",
  "Tswana",
  "Tulu",
  "Turkic",
  "Turkish",
  "Turkmen",
  "Tuvaluan",
  "Ukrainian",
  "Urdu",
  "Uygur",
  "Uzbek",
  "Vietnamese",
  "Waanyi",
  "Wagilak",
  "Wagiman",
  "Wajarri",
  "Walmajarri",
  "Waluwarra",
  "Wambaya",
  "Wangkajunga",
  "Wangkangurru",
  "Wangkatha",
  "Wangurri",
  "Wanyjirra",
  "Wardaman",
  "Wargamay",
  "Warlmanpa",
  "Warlpiri",
  "Warnman",
  "Warramiri",
  "Warumungu",
  "Welsh",
  "Wergaia",
  "Western Arrarnta",
  "Western Desert Languages",
  "Wik Mungkan",
  "Wik Ngathan",
  "Wiradjuri",
  "Worla",
  "Worrorra",
  "Wu",
  "Wubulkarra",
  "Wunambal",
  "Wurlaki",
  "Xhosa",
  "Yakuy",
  "Yankunytjatjara",
  "Yan-nhangu",
  "Yanyuwa",
  "Yapese",
  "Yawuru",
  "Yiddish",
  "Yidiny",
  "Yindjibarndi",
  "Yinhawangka",
  "Yorta Yorta",
  "Yoruba",
  "Yugambeh",
  "Yulparija",
  "Yumplatok (Torres Strait Creole)",
  "Yupangathi",
  "Zomi",
  "Zulu",
];
